// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__3Kpsp","current":"style_current__2LRRE","arrow":"style_arrow__11NsG"};